import { ChangeDetectionStrategy, Component, Inject, LOCALE_ID } from '@angular/core';

import { RouterModule } from '@angular/router';
import { CountrySelectService } from '../../../services';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-country-select',
  standalone: true,
  styleUrls: ['./country-select.component.scss'],
  imports: [NgClass, RouterModule],
  templateUrl: './country-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppCountrySelectComponent {
  protected isDropdownOpen: boolean = false;
  protected localeId: string = '';
  protected selectedCountry: any = '';
  protected countries: any[] = [];

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private countrySelectService: CountrySelectService,
  ) {
    this.localeId = this.locale;
    this.countries = this.countrySelectService.getCountries();
    let localeFound = this.countries.find((item) => item.value === this.locale);
    if (localeFound) {
      this.countries.forEach((item) => {
        if (item.value === localeFound.value) {
          item.checked = true;
        }
      });
    }
    this.getSelectedCountry();
  }

  getSelectedCountry() {
    this.countries.forEach((item) => {
      if (item.checked) {
        this.selectedCountry = item;
      }
    });
  }
}
